export const donutChartI18NDe = {
    projectLabel: "Alle Projekte",
    userLabel: "Alle Benutzer",
    othersLabel: "Andere",
};
